import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PlanningOverviewPage } from './planning-overview';
import { MatIconModule } from '@angular/material';

@NgModule({
  declarations: [
    PlanningOverviewPage,
  ],
  imports: [
    IonicPageModule.forChild(PlanningOverviewPage),
    MatIconModule
  ],
})
export class PlanningPageOverviewModule {}



// WEBPACK FOOTER //
// ./src/pages/planning-overview/planning-overview.module.ts